
import { Interview } from "@/types/interview";
import { InterviewManagementFacade } from "./management/interviewManagementFacade";

// Sample implementation of InterviewService
export class InterviewService {
  static async getPublishedInterviews(): Promise<Interview[]> {
    try {
      // In a real implementation, this would fetch from an API
      // For now, we'll return mock data or an empty array
      return await InterviewManagementFacade.getPublishedInterviews();
    } catch (error) {
      console.error("Error fetching published interviews:", error);
      throw error;
    }
  }

  static async getFeederInterviews(): Promise<Interview[]> {
    // Fetching feeder interviews
    // In a real implementation, this would fetch from an API
    return await InterviewManagementFacade.getFeederInterviews();
  }

  static async publishInterview(interviewId: string): Promise<boolean> {
    // Publishing interview
    return await InterviewManagementFacade.publishInterview(interviewId);
  }

  static async deleteInterview(interviewId: string): Promise<boolean> {
    // Deleting interview
    return await InterviewManagementFacade.deleteInterview(interviewId);
  }

  static async markForFeeder(interviewId: string): Promise<boolean> {
    return InterviewManagementFacade.markForFeeder(interviewId);
  }

  static async updateInterview(interviewId: string, updateData: Partial<Interview>): Promise<boolean> {
    return InterviewManagementFacade.updateInterview(interviewId, updateData);
  }
}
